module.exports = __webpack_public_path__ + "static/media/bg.e6ed59ff.jpg";